import React from 'react'
// styles
import './styles.cus.scss'

const CompleteFormBaner = () => {
  return (
    <div className="containerFrom flex justify-center">
      <div className="w-full flex flex-col justify-center items-center rounded-lg p-[20px]">
        <h2 className="heading4 lg:text-[30px] xl:text-[35px] 2xl:text-[45px] uppercase">
          Thank you! <br /> Your submission has been received!
        </h2>
      </div>
    </div>
  )
}

export default CompleteFormBaner
